import { render, staticRenderFns } from "./TacNotes.vue?vue&type=template&id=07ad5f7e"
import script from "./TacNotes.vue?vue&type=script&lang=js"
export * from "./TacNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports